<template>
  <div>
      <div :key="ligneCommande.id"
          v-for="ligneCommande in dcf.lignesCommande">
        <app-ligne-remise-sous-total
          v-if="ligneCommande.type === typeSousTotal ||
                ligneCommande.type === typeRemise"
          class="has-background-table-second-color mgb-25px"
          :ligneCommande="ligneCommande" />
        <app-ligne-normale
          v-if="ligneCommande.type === typeArticle
                && !ligneCommande.referencePersonnalise"
          :sens="dcf.sens"
          :societe-id="$route.params.id ? dcf.societeId : societeActiveId"
          class="has-background-table-second-color mgb-25px"
          :ligneCommande="ligneCommande" />
        <app-ligne-produit-regroupement
          v-if="ligneCommande.type === typeRegroupement
                && !ligneCommande.referencePersonnalise"
          :sens="dcf.sens"
          :societe-id="$route.params.id ? dcf.societeId : societeActiveId"
          class="has-background-table-second-color mgb-25px"
          :ligneCommande="ligneCommande" />
        <app-ligne-regroupement-personnalise
          v-if="ligneCommande.type === typePersonnalise"
          class="has-background-table-second-color mgb-25px"
          :ligneCommande="ligneCommande"
          :societe-id="$route.params.id ? dcf.societeId : societeActiveId"
          :sens="dcf.sens"
          :lignesCommande="dcf.lignesCommande" />
      </div>
  </div>
</template>
<script>

import { createNamespacedHelpers } from 'vuex';
import * as devisConf from '@/configuration/devisConf';
import appLigneRemiseSousTotal from './ligneCommandeRemiseSousTotal';
import appLigneNormale from './ligneCommandeProduitNormal';
import appLigneProduitRegroupement from './ligneCommandeProduitRegroupement';
import appLigneRegroupementPersonnalise from './ligneCommandeRegroupementPersonnalise';

const Societes = createNamespacedHelpers('societe');

export default {
  name: 'listeLigneVentesProduit',
  props: ['dcf'],
  components: {
    appLigneRemiseSousTotal,
    appLigneNormale,
    appLigneProduitRegroupement,
    appLigneRegroupementPersonnalise,
  },
  computed: {
    ...Societes.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  data() {
    return {
      typeArticle: devisConf.NORMAL,
      typeSousTotal: devisConf.SOUS_TOTAL,
      typePersonnalise: devisConf.PERSONNALISE,
      typeCommentaire: devisConf.COMMENTAIRE,
      typeRegroupement: devisConf.REGROUPEMENT,
      typeRemise: devisConf.REMISE,
    };
  },
};
</script>
